import request from './index'
// import QS from 'qs'
/**
 * 字典-车辆类型列表
 * @param
 */
export const  getVehicleTypeList = query=> {
  return request({
    url: '/zhongcheyun/vehicletype/list/total',
    method: 'GET',
    params: query,
    headers: { scope: 1 }
  })
}



// WEBPACK FOOTER //
// ./src/api/waybill.js